<template>
  <div>
    <el-dialog ref="dialog" :close-on-press-escape="false" :close-on-click-modal="false" :visible.sync="dialogVisible"
      :width="web ? '550px' : '100%'" class="logindialog">
      <div style="text-align: center;">
        <img style="margin: 0 auto;" src="../../assets/img/logo.png" alt="">
        <!-- <div v-if="loginTpye == 'login'" class="text-center">Login with password</div> -->
      </div>
      <div class="form-wrap">
        <el-form :model="user" :rules="rules" ref="userForm" label-position="left" label-width="145px">
          <el-form-item label="Username (ユーザー名)" prop="name">
            <el-input v-model="user.name"></el-input>
          </el-form-item>

          <el-form-item v-if="loginTpye == 'register' || loginTpye == 'newPassword'" label="Code (コード)" prop="code">
            <div class="flex">
              <el-input v-model="user.code"></el-input>
              <button type="button" v-if="loginTpye == 'register'" style="width:28%;margin-left: 12px;" @click="codeFun"
                class="btn2">Receive</button>
              <button type="button" v-if="loginTpye == 'newPassword'" style="width:28%;margin-left: 12px;"
                @click="codeFunPassword" class="btn2">Receive</button>
            </div>
          </el-form-item>

          <!-- <div v-if="loginTpye == 'register'" class="wenti">
            <span>Can't receive the verification code</span>
            <el-tooltip v-if="loginTpye == 'register'" class="item" effect="light" placement="top-start">
              <div slot="content">Suggest using mainstream email such as <br> Gmail to receive verification codes
              </div>
              <span class="item-tool">?</span>
            </el-tooltip>
          </div> -->

          <el-form-item v-if="loginTpye == 'login'" label="Password (パスワード)" prop="password">
            <el-input v-model="user.password" show-password></el-input>
          </el-form-item>
          <el-form-item v-if="loginTpye == 'register' || loginTpye == 'newPassword'" label="Password (パスワード)"
            prop="passwordRegister">
            <el-input v-model="user.passwordRegister" show-password></el-input>
          </el-form-item>

          <div v-if="loginTpye == 'login'">
            <div @click="passwordFun" class="retrieve">
              <div>Forgot password</div>
              <div>パスワードを忘れた</div>
            </div>
          </div>
          <div v-if="loginTpye == 'register'">
            <el-form-item label="Notice(お知らせ)" prop="checked">
              <el-checkbox v-model="user.checked">I am over 18 years old (私は18歳以上です)</el-checkbox>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <button type="button" v-if="loginTpye == 'login'" class="btn2" @click="login">LOGIN (ログイン)</button>
        <button type="button" v-if="loginTpye == 'register'" class="btn2" @click="register">REGISTER (登録)</button>
        <button type="button" v-if="loginTpye == 'newPassword'" class="btn2" @click="newPasswordFun">RESET
          PASSWORD (パスワードをリセットする)</button>
        <div class="text-center" v-if="loginTpye == 'login'" style="margin:20px 0 40px;">
          <span></span><span @click="goRegister" class="register">Register (登録)</span>
        </div>
        <div class="text-center" v-if="loginTpye == 'register' || loginTpye == 'newPassword'"
          style="margin:20px 0 40px;">
          <!-- <span @click="goLogin" class="register">login with password</span> -->
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
export default {
  name: 'loginDialog',
  data() {
    let validatePassword = (rule, value, callback) => {
      let reg = /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]+$/;
      if (!reg.test(value)) {
        callback(new Error('The password must contain both numbers and letters'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      web: this.$utils.isDesktop(),
      loginTpye: 'login',
      user: {
        name: '',
        password: '',
        passwordRegister: '',
        code: '',
        checked: []
      },
      rules: {
        checked: [
          { type: 'array', required: true, message: 'After checking, registration can be completed. If unchecked, it is considered not meeting the conditions and registration cannot be completed', trigger: 'change' }
        ],
        name: [
          { required: true, type: 'email', message: 'Please enter the correct email format', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: 'Please enter the password', trigger: 'blur' }
        ],
        passwordRegister: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        code: [
          { required: true, message: 'Please enter the code', trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    ...mapActions(['getUser']),
    show() {
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
    },
    login() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          try {
            let data = {
              email: this.user.name,
              password: this.user.password,
              webName: 'realfungaming',
            }
            let res = await this.$api.login.loginUser(data)
            if (res && res.data) {
              sessionStorage.setItem('game', 'login')
              sessionStorage.setItem('gameName', this.user.name)
              sessionStorage.setItem('token', res.data.token)
              this.getUser()
              this.$store.commit('getgameName')
              this.$emit('gameName', this.user.name)
              this.hide()
              this.$emit('childEvent')
            }
          } catch (error) { console.log(error); }
        }
      })
    },
    register() {
      this.$refs.userForm.validate(async (valid) => {
        if (valid) {
          try {
            let data = {
              email: this.user.name,
              verificationCode: this.user.code,
              password: this.user.passwordRegister,
              webName: 'realfungaming',
            }
            let res = await this.$api.login.registerUser(data)
            if (res) {
              this.$message({
                message: 'Registered user successfully',
                type: "success",
              })
              this.goLogin()
            }
          } catch (error) { console.log(error); }
        }
      })

    },
    async newPasswordFun() {
      try {
        let data = {
          email: this.user.name,
          code: this.user.code,
          newPassword: this.user.passwordRegister,
        }
        let res = await this.$api.login.resetPassword(data)
        if (res) {
          this.$message({
            message: res.data.message,
            type: "success",
          })
          this.goLogin()
        }
      } catch { console.log() } finally { console.log() }
    },
    async codeFunPassword() {
      let data = { email: this.user.name }
      let res = await this.$api.login.forgotPassword(data)
      if (res) {
        this.$message({
          message: res.data.message,
          type: "success",
        })
      }
    },
    async codeFun() {
      let data = { email: this.user.name }
      let res = await this.$api.login.registerCode(data)
      if (res) {
        this.$message({
          message: res.data.message,
          type: "success",
        })
      }
    },
    passwordFun() {
      this.loginTpye = 'newPassword'
      this.user.name = ''
      this.user.password = ''
    },
    goRegister() {
      this.loginTpye = 'register'
      this.user.name = ''
      this.user.password = ''
    },
    goLogin() {
      this.loginTpye = 'login'
      this.user.name = ''
      this.user.password = ''
    }
  }
}
</script>

<style lang="less" scoped>
.logindialog {
  padding: 0px 10px;
}

.btn2 {
  width: 100%;
  background: #4b98ea;
  border: 1px solid #4b98ea;
  color: #fff;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
  border-radius: 6px;
  padding: 0;
  text-align: center;
}

.retrieve {
  color: #4b98ea;
  flex-direction: column;
  align-items: end;
  cursor: pointer;
  display: flex;
}

.register {
  color: #4b98ea;
  border-bottom: 1px solid #4b98ea;
  cursor: pointer;
}

.item-tool {
  font-weight: bold;
  margin-left: 4px;
  font-size: 18px;
  cursor: pointer;
}

.wenti {
  // color: #4b98ea;
  color: #000;
  display: flex;
  justify-content: end;
  align-items: center;
  position: absolute;
  right: 5%;
  font-size: 13px;
}

/deep/.el-dialog {
  border-radius: 16px;
}

/deep/.el-dialog__headerbtn {
  font-size: 20px;
  top: 10px;
  right: 18px;
}

/deep/.el-form-item {
  margin: 16px 0 0;
  display: flex;
  align-items: center;
}

/deep/.el-dialog__body {
  padding: 20px 30px;
}

/deep/.el-dialog__footer {
  padding: 10px 30px 20px;
}

/deep/.el-form-item__content {
  width: 80%;
  margin-left: 0 !important;
}
</style>